import React from 'react'

const Button = (props) => (
    <a className={`button ${props.styleClass}`} href={props.link}>
        {props.text}
    </a>
)

export default Button
